import React from "react";

import _ from "lodash";

import { withRouter } from "react-router";

import { formatDate, formatCurrency } from "../lib/formatters";

import { Subscribe } from "unstated";

import { SalesHistoryContainer } from "./containers/sales-history-container";

import { from } from "rxjs";
import { useObservable } from "rxjs-hooks";

const OrderDetailView = ({ salesHistoryContainer, params }) => {
  const order = useObservable(() =>
    from(salesHistoryContainer.get(params.orderId))
  );

  return (
    order && (
      <div className="container-fluid">
        <div className="row">
          <div className="col-sm-6">
            <div>
              <strong>Sale #: </strong>
              {order.saleID}
            </div>
            <div>
              <strong>Date of Invoice: </strong>
              {formatDate(order.createdAt)}
            </div>
            <div>
              <strong>Subtotal: </strong>
              {formatCurrency(order.calcSubtotal)}
            </div>
            <div>
              <strong>Tax: </strong>
              {formatCurrency(order.taxTotal)}
            </div>
            <div>
              <strong>Total: </strong>
              {formatCurrency(order.total)}
            </div>

            <br />

            {order.deliveryComplete && (
              <React.Fragment>
                <div>
                  <div>
                    <strong>Delivered on: </strong>
                    {formatDate(
                      order.customerSignature.customerSignatureDate
                    )}{" "}
                  </div>
                </div>
                <br />
              </React.Fragment>
            )}
          </div>
          <div className="col-sm-6">
            {_.map(_.sortBy(order.saleLine, "itemID"), (line, i) => {
              return (
                <div key={i} className="mb-2">
                  <div>
                    <strong>Item: </strong>
                    {_.has(line, "description")
                      ? line.description
                      : line.itemID}
                  </div>
                  <div>
                    <strong>Price: </strong>
                    {formatCurrency(line.unitPrice)}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    )
  );
};

const OrderDetail = withRouter((props) => (
  <Subscribe to={[SalesHistoryContainer]}>
    {(salesHistoryContainer) => (
      <OrderDetailView
        {...props}
        salesHistoryContainer={salesHistoryContainer}
      />
    )}
  </Subscribe>
));

export { OrderDetail };
